import styled from "styled-components";

import CardBase from "../CardBase";
import { ColorPaletteRoleBackgroundOptions } from "../../../../types/theming";
import { StyledCardProps, CardTrimColorOptions } from "./Card.types";

export const TRIM_HEIGHT = "xs";

const trimColorMapping: CardTrimColorOptions = {
	bg_dark: "bg_light",
	bg_dark_variant: "bg_light",
	bg_light: "bg_dark_variant",
	bg_light_variant: "bg_dark_variant",
	bg_white: "bg_dark_variant",
};

export const StyledCard = styled(
	({ interactive, ...props }: StyledCardProps) => <CardBase {...props} />
)`
	${({ interactive }) => ({
		transition: "box-shadow 300ms ease-in-out",
		...(interactive && {
			"&:hover": {
				boxShadow: `4px 4px 16px rgba(0, 0, 0, 0.15)`,
			},
		}),
	})}
`;

export const StyledTrim = styled.div<{
	backgroundColor: ColorPaletteRoleBackgroundOptions;
}>`
	${({ theme, backgroundColor }) => ({
		width: "100%",
		height: theme.space[TRIM_HEIGHT],
		position: "absolute",
		backgroundColor: theme.palette.hexForRole(
			trimColorMapping[backgroundColor]
		),
		top: 0,
		left: 0,
	})}
`;
